export const comContext = {
  channel: "COM",
  type: "business",
  mappings: [
    {
      key: "businessBankAccountsGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/",
      categoryId: "BUSINESS_BANK_ACCOUNTS",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessCheckingGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/",
      categoryId: "BUSINESS_BANK_ACCOUNTS",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessChecking",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Business Checking",
      reportingData: {},
    },
    {
      key: "businessBanking",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking.html",
      categoryId: "BUSINESS_BANKING",
      page_key: "business-banking",
      reportingData: {},
    },
    {
      key: "businessCheckingApplication",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/application-requirements-checklist.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Business Application Checklist",
      reportingData: {},
    },
    {
      key: "businessCheckingCompare",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/compare-checking-accounts.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Compare Checking Accounts",
      reportingData: {},
    },
    {
      key: "businessCheckingPlatinum",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/platinum-business-checking-account-package.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Platinum Business Checking",
      reportingData: {},
    },
    {
      key: "businessCheckingGold",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/gold-business-checking-account-package.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Gold Business Checking",
      reportingData: {},
    },
    {
      key: "businessCheckingSilver",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-bank-accounts/business-checking/silver-business-checking-account-package.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "Silver Business Checking",
      reportingData: {},
    },
    {
      key: "businessCreditCardsGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-credit-cards/",
      categoryId: "BUSINESS_CREDIT_CARDS",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessCreditCardsMain",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-credit-cards.html",
      categoryId: "BUSINESS_CREDIT_CARDS",
      page_key: "business-credit-cards",
      reportingData: {},
    },

    {
      key: "businessLendingGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-lending/",
      categoryId: "BUSINESS_LENDING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessLending",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-lending.html",
      categoryId: "BUSINESS_LENDING",
      page_key: "business-lending",
      reportingData: {},
    },
    {
      key: "businessServiceGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-services/",
      categoryId: "BUSINESS_SERVICES",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessService",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-services.html",
      categoryId: "BUSINESS_SERVICES",
      page_key: "business-services",
      reportingData: {},
    },
    {
      key: "businessServicePaymentsGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-services/payment-processing/",
      categoryId: "BUSINESS_SERVICES_PAYMENT",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessServicePayments",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-services/payment-processing.html",
      categoryId: "BUSINESS_SERVICES_PAYMENT",
      page_key: "payment-processing",
      reportingData: {},
    },
    {
      key: "businessExploreIndustryGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/explore-by-industry/",
      categoryId: "BUSINESS_EXPLORE_INDUSTRY",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessExploreIndustry",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/explore-by-industry.html",
      categoryId: "BUSINESS_EXPLORE_INDUSTRY",
      page_key: "explore-by-industry",
      reportingData: {},
    },
    {
      key: "businessResourceGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/business-resource-center/",
      categoryId: "BUSINESS_RESOURCE_CENTER",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessResource",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-resource-center.html",
      categoryId: "BUSINESS_RESOURCE_CENTER",
      page_key: "business-resource-center",
      reportingData: {},
    },
    {
      key: "businessManageGeneric",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/business-banking/managing-a-business/",
      categoryId: "BUSINESS_MANAGING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/managing-a-business.html",
      categoryId: "BUSINESS_MANAGING",
      page_key: "managing-a-business",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-banking/business-essentials-checking.html",
      categoryId: "BUSINESS_BANK_ACCOUNTS",
      page_key: "business-essentials",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-checking/business-checking-promo.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-checking/business-checking-promo-trigger.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-checking/business-checking-promo-affiliate.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-checking/business-checking-promo-deposit.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "DEFAULT",
      reportingData: {},
    },
    {
      key: "businessManage",
      useDefault: false,
      isGeneric: false,
      useReportingData: false,
      url: "/business-checking/business-checking-promo-rps.html",
      categoryId: "BUSINESS_CHECKING",
      page_key: "DEFAULT",
      reportingData: {},
    },
  ],
};
